exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content h1 div.svCarne { -webkit-mask: url(/bfportalcli/assets/img/ico-segundavia-carne.svg) no-repeat left top; -ms-mask: url(/bfportalcli/assets/img/ico-segundavia-carne.svg) no-repeat left top;}\n.space{padding-right: 50px;}\n.subMessage{font-size: .9rem;}\n\n/* --- IE 10 e 11 --- */\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .content h1 div.svCarne { background:  url(/bfportalcli/assets/img/ico-segundavia-carne.svg) no-repeat left top; background-color: transparent !important; margin-top: -5px; }\n}\n/* Microsoft Edge Browser 12+ (All) - @supports method */\n@supports (-ms-ime-align:auto) {\n    .content h1 div.svCarne { background:  url(/bfportalcli/assets/img/ico-segundavia-carne.svg) no-repeat left top; background-color: transparent !important; margin-top: -5px; }\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-segundaviacarne-cli/segundaviacarne.component.css
// module id = ../../../../../src/app/bf-segundaviacarne-cli/segundaviacarne.component.css
// module chunks = main